export const getBusinessNetwork = `query GetBusinessNetwork($companyId: ID!) {
  getBusinessNetwork(companyId: $companyId) {
    activeEmployees
    businessConnections
    firstConnections
    inNetworkConnections
  }
}
`;
